import { api } from './client';
import type { MigratedAuditLog } from '@/components/MigratedCrudHistory';

export interface PersonalNote {
  id: string;
  ownerId: string;
  text: string;
  legacyId: number | null;
  legacySobid: string | null;
  legacyCreator: string | null;
  importedAt: string | null;
  createdAt: string;
  updatedAt: string;
  isArchived: boolean;
  archivedAt: string | null;
}

export interface SavePersonalNoteDto {
  text: string;
}

export const personalNotesApi = {
  getAll: async (params: { search?: string; archived?: boolean } = {}): Promise<PersonalNote[]> => {
    const { data } = await api.get('/personal-notes', {
      params: {
        search: params.search?.trim() || undefined,
        archived: params.archived || undefined,
      },
    });
    return data.items || [];
  },

  getHistory: async (id: string): Promise<{ items: MigratedAuditLog[]; total: number }> => {
    const { data } = await api.get(`/personal-notes/${id}/history`);
    return data;
  },

  create: async (body: SavePersonalNoteDto): Promise<PersonalNote> => {
    const { data } = await api.post('/personal-notes', body);
    return data;
  },

  update: async (id: string, body: SavePersonalNoteDto): Promise<PersonalNote> => {
    const { data } = await api.patch(`/personal-notes/${id}`, body);
    return data;
  },

  archive: async (id: string): Promise<void> => {
    await api.post(`/personal-notes/${id}/archive`);
  },
};
